/* Der Schwarze Kapitän – client for the game service ("Dienst").
   Loaded after js/spiel.js. Without an API URL (window.KAPITAEN_CONFIG.api or ?api=) it does nothing and the
   localStorage mock stays in charge. With an API URL it replaces window.Spiel by an object with the same members
   as the mock, plus:
     bereit            Promise, resolves once the first state is known (or the service turned out unreachable)
     online            true while the service answers; false = fallback (cached state, writes are queued)
     api, demo         configured base URL; demo controls allowed (KAPITAEN_CONFIG.demoLeiste or ?demo=1)
     anheuern(mail, name) -> Promise<{ok, status} | {ok:false, fehler}>
     aktualisiere()    re-reads the state
     richtige(n, i), istRichtig(n, i), codeMap()
     demoLokal         true while the demo view shows a stage the service has not opened (see below)
     testStufe         true while the service itself serves a per-session test stage (State.stufe_override)
   Demo view of another stage (Feedback 2 item 4): with the demo controls, stufeOverride may show a stage that differs
   from the service's real stage. The service would refuse answers and votes there (409 noch_nicht_offen), so for that
   stage they are kept only in this browser (M.stand + localStorage K_DEMO, keyed by stage id) and survive a reload; the
   page says so (seite.js TEXT_DEMO_LOKAL). Answers and votes on the real stage go to the service unchanged.
   Test stage of the service (item 8): POST /api/session also sends the URL params e and stufe; in test mode the service
   may answer with a per-session stage (State.stufe = that stage, State.stufe_override = true). The page renders it like
   any stage and shows TEXT_TESTSTUFE; the service stores those answers and votes.
   Events on document: 'spiel:update' after every state change, 'spiel:fehler' (detail: 'geschlossen' |
   'noch_nicht_offen' | 'offline').
   The server decides stage, majorities, distribution, Ladung and whether an answer is right; this file never reads
   fragen[].richtig from the local data. The mock object is reused as stage table, rule engine (locks, conditions) and
   view-state holder; its localStorage persistence is never triggered from here. */
(function (global) {
  'use strict';
  var CFG = global.KAPITAEN_CONFIG || {};
  var q = new URLSearchParams(global.location.search);
  var API = String(q.get('api') || CFG.api || '').trim().replace(/\/+$/, '');
  var M = global.Spiel;
  if (!API || !M) return;

  var DEMO = CFG.demoLeiste === true || q.get('demo') === '1';
  var K_SID = 'kapitaen-sid', K_CACHE = 'kapitaen-dienst-stand', K_QUEUE = 'kapitaen-dienst-warteschlange', K_DEMO = 'kapitaen-dienst-demo';
  var TIMEOUT = 6000, RETRY = 15000, POLL_DOI = 30000;
  var doc = global.document;

  var sid = lies(K_SID);
  var urlToken = (q.get('t') || '').trim() || null;
  var zustand = null;            // last State from the service
  var online = false;
  var stufeOverride = null;      // demo only: view another stage
  var nameLokal = '';
  var mailHinweis = false;      // true after anheuern answered "pending" (new or known address)       // anheuern with an address the service already knows: the session stays unbound
                                 // (the ?t= link from that person's mail binds it), the page still shows "check your mail"

  var aWahl = q.has('a') ? q.get('a').toUpperCase() : null;
  var cache = liesJson(K_CACHE) || {};
  var richtig = cache.sid && cache.sid === sid && cache.richtig ? cache.richtig : {};   // "n-i" -> bool (from the server)
  var queue = liesJson(K_QUEUE) || [];
  var demoStand = liesJson(K_DEMO) || {};   // stage id -> { antworten: {n: {i: idx}}, stimmen: {n: key}, signal: key }
  var retryTimer = null, pollTimer = null, zuletztGeholt = 0, startLaeuft = null;

  /* ---- storage (private mode safe) ---- */
  function lies(k) { try { return global.localStorage.getItem(k); } catch (e) { return null; } }
  function schreibe(k, v) { try { if (v === null) global.localStorage.removeItem(k); else global.localStorage.setItem(k, v); } catch (e) { /* ignore */ } }
  function liesJson(k) { try { return JSON.parse(lies(k) || 'null'); } catch (e) { return null; } }
  function sichereCache() { schreibe(K_CACHE, JSON.stringify({ sid: sid, state: zustand, richtig: richtig })); }
  function sichereQueue() { schreibe(K_QUEUE, queue.length ? JSON.stringify(queue) : null); }
  function sichereDemo() { schreibe(K_DEMO, Object.keys(demoStand).length ? JSON.stringify(demoStand) : null); }

  /* ---- demo view of a stage the service has not opened: answers and votes stay in this browser ---- */
  function echteStufe() { return zustand && online ? zustand.stufe : stufeNachDatum(); }
  function demoLokal() { return !!stufeOverride && stufeOverride !== echteStufe(); }
  function demoFach() { var f = demoStand[stufeOverride] = demoStand[stufeOverride] || {}; f.antworten = f.antworten || {}; f.stimmen = f.stimmen || {}; return f; }
  function demoEinmischen() {
    if (!demoLokal()) return;
    var s = M.stand, f = demoStand[stufeOverride] || {};
    Object.keys(f.antworten || {}).forEach(function (n) {
      s.antworten[n] = s.antworten[n] || {};
      Object.keys(f.antworten[n]).forEach(function (i) { if (s.antworten[n][i] === undefined) s.antworten[n][i] = +f.antworten[n][i]; });
    });
    Object.keys(f.stimmen || {}).forEach(function (n) { if (!s.stimmen[n]) s.stimmen[n] = f.stimmen[n]; });
    if (f.signal && !s.signal) s.signal = f.signal;
  }
  function demoSpeichern(typ, b) {
    var f = demoFach(), s = M.stand;
    if (typ === 'antwort') { (f.antworten[b.etappe] = f.antworten[b.etappe] || {})[b.frage] = b.antwort; (s.antworten[b.etappe] = s.antworten[b.etappe] || {})[b.frage] = b.antwort; }
    else if (b.etappe === 'signal') { f.signal = s.signal = b.option; }
    else { f.stimmen[b.etappe] = s.stimmen[b.etappe] = b.option; }
    sichereDemo(); update(typ);
  }

  function melde(art, detail) { doc.dispatchEvent(new CustomEvent(art, { detail: detail })); }
  function update(grund) { melde('spiel:update', { grund: grund }); }

  /* ---- HTTP ---- */
  function rufe(method, pfad, body) {
    var ctrl = global.AbortController ? new global.AbortController() : null;
    var timer = ctrl ? global.setTimeout(function () { ctrl.abort(); }, TIMEOUT) : null;
    var opts = { method: method, cache: 'no-store', credentials: 'omit' };
    if (ctrl) opts.signal = ctrl.signal;
    if (body) { opts.headers = { 'Content-Type': 'application/json' }; opts.body = JSON.stringify(body); }
    return global.fetch(API + pfad, opts).then(function (r) {
      global.clearTimeout(timer);
      return r.json().catch(function () { return {}; }).then(function (d) { return { status: r.status, ok: r.ok, daten: d || {} }; });
    }, function () {
      global.clearTimeout(timer);
      return { status: 0, ok: false, netz: true, daten: {} };
    });
  }
  function ausfall(r) { return r.netz || r.status >= 500; }

  /* ---- stage by date (fallback while offline) ---- */
  function heuteBerlin() {
    try { return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()); } catch (e) { return new Date().toISOString().slice(0, 10); }
  }
  function stufeNachDatum() {
    var d = heuteBerlin(), id = 'vorab';
    Object.keys(M.DATUM_STUFE).sort().forEach(function (k) { if (k <= d) id = M.DATUM_STUFE[k]; });
    return id;
  }

  /* ---- server State -> view state (M.stand) ---- */
  function leer() {
    var s = M.stand;
    s.stufe = stufeOverride || stufeNachDatum(); s.token = false; s.name = ''; s.pfade = Object.assign({}, M.STANDARD_PFADE);
    s.stimmen = {}; s.antworten = {}; s.signal = null; s.angeheuert = false; s.doi = false; s.bohnenVorher = 0; s.a = aWahl;
    demoEinmischen();
  }
  function anwenden(st) {
    var s = M.stand, k = st.kontakt || {};
    zustand = st;
    s.stufe = stufeOverride || (online ? st.stufe : stufeNachDatum());
    s.token = k.status === 'subscribed';
    s.angeheuert = k.status === 'subscribed';
    s.doi = k.status === 'pending' || (mailHinweis && k.status !== 'subscribed');
    s.doiBekannt = mailHinweis && k.status !== 'subscribed' && k.status !== 'pending';   // known address, session stays a guest
    s.name = k.name || nameLokal || '';
    s.pfade = Object.assign({}, M.STANDARD_PFADE, st.pfade || {});
    s.stimmen = {}; s.signal = null;
    Object.keys(st.stimmen || {}).forEach(function (n) { if (n === 'signal') s.signal = st.stimmen[n]; else s.stimmen[n] = st.stimmen[n]; });
    s.antworten = {};
    Object.keys(st.antworten || {}).forEach(function (n) {
      s.antworten[n] = {};
      Object.keys(st.antworten[n]).forEach(function (i) { s.antworten[n][i] = +st.antworten[n][i]; });
    });
    queue.forEach(optimistisch);   // answers/votes waiting for the connection stay visible
    demoEinmischen();              // demo view of an unopened stage: what this browser remembered for it
    var e = M.stufe().zustand === 'B' ? M.stufe().etappe : 0;
    s.bohnenVorher = Math.max(0, (st.bohnen || 0) - (e ? richtigInDienst(e) : 0));
    s.a = aWahl;
  }
  function optimistisch(item) {
    var s = M.stand, b = item.body;
    if (item.typ === 'antwort') { s.antworten[b.etappe] = s.antworten[b.etappe] || {}; if (s.antworten[b.etappe][b.frage] === undefined) s.antworten[b.etappe][b.frage] = b.antwort; }
    else if (b.etappe === 'signal') { if (!s.signal) s.signal = b.option; }
    else if (!s.stimmen[b.etappe]) s.stimmen[b.etappe] = b.option;
  }
  function zuruecknehmen(item) {
    var s = M.stand, b = item.body;
    if (item.typ === 'antwort') { if (s.antworten[b.etappe]) delete s.antworten[b.etappe][b.frage]; }
    else if (b.etappe === 'signal') s.signal = (zustand && zustand.stimmen && zustand.stimmen.signal) || null;
    else { var alt = zustand && zustand.stimmen && zustand.stimmen[String(b.etappe)]; if (alt) s.stimmen[b.etappe] = alt; else delete s.stimmen[b.etappe]; }
  }

  /* ---- session start / reconnect ---- */
  function session() {
    /* e / stufe: per-session test stage, used by the service only in test mode (ignored otherwise, never a 4xx) */
    return rufe('POST', '/api/session', { sid: sid || null, token: urlToken, e: q.get('e'), stufe: q.get('stufe'), test_key: CFG.testKey || null }).then(function (r) {
      if (!r.ok) throw r;
      if (r.daten.sid !== sid) { sid = r.daten.sid; schreibe(K_SID, sid); richtig = {}; }
    });
  }
  function holeState() {
    return rufe('GET', '/api/state?sid=' + encodeURIComponent(sid || '')).then(function (r) {
      if (r.status === 404) { sid = null; schreibe(K_SID, null); throw r; }
      if (!r.ok) throw r;
      zuletztGeholt = Date.now();
      return r.daten;
    });
  }
  function leeren() {
    if (!queue.length) return Promise.resolve();
    var item = queue[0];
    return post(item).then(function (r) {
      if (ausfall(r)) throw r;
      queue.shift(); sichereQueue();
      return leeren();
    });
  }
  function start() {
    if (startLaeuft) return startLaeuft;
    startLaeuft = session().then(leeren).then(holeState).then(function (st) {
      online = true; anwenden(st); sichereCache(); stopRetry();
      return nachfragen();
    }).catch(function (r) {
      if (r instanceof Error) global.setTimeout(function () { throw r; });          // a bug, not a network problem: keep it visible
      if (r && r.status === 404 && !r.netz) { startLaeuft = null; return start(); }   // stale sid: start over once
      offline();
    }).then(function () { startLaeuft = null; pollen(); });
    return startLaeuft;
  }
  function offline() {
    var war = online;
    online = false;
    if (zustand) anwenden(zustand); else if (cache.state && cache.sid === sid) anwenden(cache.state); else { leer(); queue.forEach(optimistisch); }
    if (war) melde('spiel:fehler', 'offline');
    if (!retryTimer) retryTimer = global.setInterval(function () { start().then(function () { if (online) update('online'); }); }, RETRY);
  }
  function stopRetry() { if (retryTimer) { global.clearInterval(retryTimer); retryTimer = null; } }
  /* The correctness of earlier answers is not part of State; repeating an answer is idempotent and returns it. */
  function nachfragen() {
    var st = M.stufe(); if (st.zustand !== 'B') return Promise.resolve();
    var n = st.etappe, a = M.stand.antworten[n] || {};
    var offen = Object.keys(a).filter(function (i) { return richtig[n + '-' + i] === undefined; });
    return Promise.all(offen.map(function (i) {
      return rufe('POST', '/api/antwort', { sid: sid, etappe: n, frage: +i, antwort: a[i] }).then(function (r) {
        if (r.ok) richtig[n + '-' + i] = !!r.daten.richtig;
      });
    })).then(function () { if (zustand && offen.length) anwenden(zustand); sichereCache(); });
  }
  function pollen() {
    if (pollTimer) { global.clearTimeout(pollTimer); pollTimer = null; }
    if (online && M.stand.doi) pollTimer = global.setTimeout(function () { if (doc.visibilityState !== 'hidden') aktualisiere(); else pollen(); }, POLL_DOI);
  }
  function aktualisiere() {
    if (!online) return start().then(function () { update('online'); });
    return holeState().then(function (st) { anwenden(st); sichereCache(); return nachfragen(); }, function (r) { if (ausfall(r)) offline(); })
      .then(function () { pollen(); update('state'); });
  }

  /* ---- writes ---- */
  function post(item) {
    var b = Object.assign({ sid: sid }, item.body);
    return rufe('POST', item.typ === 'antwort' ? '/api/antwort' : '/api/stimme', b).then(function (r) {
      if (r.ok && item.typ === 'antwort') richtig[item.body.etappe + '-' + item.body.frage] = !!r.daten.richtig;
      if (!r.ok && !ausfall(r)) {
        zuruecknehmen(item);
        if (r.status === 409) melde('spiel:fehler', r.daten.error || 'geschlossen');
        if (r.status === 429) melde('spiel:fehler', 'zu_viele');
      }
      return r;
    });
  }
  function senden(item) {
    optimistisch(item);
    if (!online) { queue.push(item); sichereQueue(); update(item.typ); return; }
    update(item.typ);
    post(item).then(function (r) {
      if (ausfall(r)) { queue.push(item); sichereQueue(); offline(); update('offline'); return; }
      if (r.status === 404) { queue.push(item); sichereQueue(); sid = null; schreibe(K_SID, null); start().then(function () { update('state'); }); return; }
      if (r.ok && r.daten.state) { anwenden(r.daten.state); sichereCache(); }
      update(item.typ);
    });
  }
  function antworte(n, i, idx) {
    var a = M.stand.antworten[n];
    if (a && a[i] !== undefined) return istRichtig(n, i);
    if (demoLokal()) { demoSpeichern('antwort', { etappe: +n, frage: +i, antwort: +idx }); return istRichtig(n, i); }
    senden({ typ: 'antwort', body: { etappe: +n, frage: +i, antwort: +idx } });
    return null;
  }
  function stimme(n, key) { if (M.stand.stimmen[n]) return; if (demoLokal()) demoSpeichern('stimme', { etappe: +n, option: key }); else senden({ typ: 'stimme', body: { etappe: +n, option: key } }); }
  function signalStimme(key) { if (M.stand.signal) return; if (demoLokal()) demoSpeichern('stimme', { etappe: 'signal', option: key }); else senden({ typ: 'stimme', body: { etappe: 'signal', option: key } }); }
  function anheuern(mail, name) {
    nameLokal = String(name || '').slice(0, 40);
    var go = online ? Promise.resolve() : start();
    return go.then(function () {
      if (!online) return { ok: false, fehler: 'offline' };
      return rufe('POST', '/api/anheuern', { sid: sid, email: mail, name: nameLokal }).then(function (r) {
        if (r.ok) { mailHinweis = r.daten.status === 'pending'; anwenden(r.daten.state); sichereCache(); pollen(); update('anheuern'); return { ok: true, status: r.daten.status }; }
        if (ausfall(r) && r.netz) { offline(); update('offline'); }
        return { ok: false, fehler: r.netz ? 'offline' : (r.daten.error || 'fehler') };
      });
    });
  }

  /* ---- reads ---- */
  /* demo view of an unopened stage: the verdict comes from the local data if it carries one (daten.js, the file:// demo);
     daten.public.js (theme) has none, then the answer stands without a verdict */
  function istRichtig(n, i) {
    if (demoLokal() && richtig[n + '-' + i] === undefined) return M.istRichtig(n, i);
    var v = richtig[n + '-' + i]; return v === undefined ? null : v;
  }
  function richtige(n, i) { var a = M.stand.antworten[n]; return istRichtig(n, i) === true && a ? a[i] : null; }
  function richtigInDienst(n) { var a = M.stand.antworten[n] || {}, c = 0; Object.keys(a).forEach(function (i) { if (richtig[n + '-' + i] === true) c++; }); return c; }
  function richtigIn(n) { var a = M.stand.antworten[n] || {}, c = 0; Object.keys(a).forEach(function (i) { if (istRichtig(n, i) === true) c++; }); return c; }
  function eigen() { return zustand && !stufeOverride; }
  function ladung() { return eigen() ? zustand.ladung : M.ladung(); }
  function pct(l) { return l === undefined && eigen() ? zustand.pct : M.pct(l === undefined ? ladung() : l); }
  function bohnen() {
    var b = zustand ? zustand.bohnen : 0, st = M.stufe();
    return demoLokal() && st.zustand === 'B' && !st.steuermann ? b + richtigIn(st.etappe) : b;   // the demo stage's beans are local too
  }
  /* Percentages from the service (largest remainder over unlocked options). Without counted votes all are 0; the
     page then shows no bars. The Signal falls back to 68/32 like ANTEILE.AUSGANG of /admin/spielstand (Finale send). */
  function anteile(key) {
    var v = zustand && zustand.verteilung && zustand.verteilung[key];
    if (!v) {
      v = {};
      if (key === 'signal') v = { ueberlaufen: 0, bleiben: 0 }; else M.etappe(+key).schiffsrat.optionen.forEach(function (o) { v[o.key] = 0; });
    }
    if (key === 'signal' && !(v.ueberlaufen + v.bleiben)) return { ueberlaufen: 68, bleiben: 32 };
    return v;
  }
  function ausgang() { return zustand ? zustand.ausgang : M.ausgang(); }
  function codeMap() { return zustand && zustand.test_mode && zustand.code_map ? zustand.code_map : {}; }

  /* ---- demo controls (only with demoLeiste / ?demo=1) ---- */
  function setzeStufe(id) {
    if (!DEMO) return;
    stufeOverride = M.STUFEN[M.stufeIndex(id)].id; M.stand.stufe = stufeOverride; M.stand.a = aWahl = null;
    neuAnwenden();
  }
  /* after a change of the demo view: rebuild the view state, with what this browser remembered for that stage */
  function neuAnwenden() { var t = M.stand.token; if (zustand) { anwenden(zustand); M.stand.token = M.stand.token || t; } else demoEinmischen(); }
  function setzePfad(n, key) { if (DEMO) M.stand.pfade[n] = key; }
  function setze(k, v) { if (k === 'name') nameLokal = v; M.stand[k] = v; }
  function zuruecksetzen() {
    if (!DEMO) return;
    sid = null; richtig = {}; zustand = null; queue = []; demoStand = {};
    schreibe(K_SID, null); schreibe(K_CACHE, null); sichereQueue(); sichereDemo(); leer();
    start().then(function () { update('reset'); });
  }
  function ausUrl() {
    if (!DEMO) return;
    var st = q.get('stufe') || CFG.stufe;
    if (st) { stufeOverride = M.STUFEN[M.stufeIndex(st)].id; M.stand.stufe = stufeOverride; neuAnwenden(); }
  }
  function inUrl() {
    if (!q.has('t') || !online) return;   // the mail token is not meant to be shared; the session (sid) keeps it
    q.delete('t');
    try { global.history.replaceState(null, '', global.location.pathname + (q.toString() ? '?' + q.toString() : '') + global.location.hash); } catch (e) { /* file:// */ }
  }

  leer();
  global.addEventListener('online', function () { if (!online) start().then(function () { if (online) update('online'); }); });
  doc.addEventListener('visibilitychange', function () { if (doc.visibilityState === 'visible' && Date.now() - zuletztGeholt > 10000) aktualisiere(); });

  global.Spiel = {
    STUFEN: M.STUFEN, NAECHSTE_POST: M.NAECHSTE_POST, STANDARD_PFADE: M.STANDARD_PFADE, DATUM_STUFE: M.DATUM_STUFE,
    get stand() { return M.stand; },
    stufe: M.stufe, stufeIndex: M.stufeIndex, etappe: M.etappe, option: M.option,
    pfad: M.pfad, bedingung: M.bedingung, gesperrt: M.gesperrt,
    ladung: ladung, ladungNach: M.ladungNach, pct: pct, aufgeloestBis: M.aufgeloestBis,
    bohnen: bohnen, bohnenMoeglich: M.bohnenMoeglich, maxVorher: M.maxVorher, antworten: M.antworten, richtigIn: richtigIn,
    richtige: richtige, istRichtig: istRichtig,
    verteilung: function (n) { return anteile(String(n)); }, signalVerteilung: function () { return anteile('signal'); }, ausgang: ausgang,
    setzeStufe: setzeStufe, antworte: antworte, stimme: stimme, signalStimme: signalStimme, setzePfad: setzePfad, setze: setze, zuruecksetzen: zuruecksetzen,
    ausUrl: ausUrl, inUrl: inUrl,
    anheuern: anheuern, aktualisiere: aktualisiere, codeMap: codeMap,
    get online() { return online; },
    get testModus() { return !!(zustand && zustand.test_mode); },
    get demoLokal() { return demoLokal(); },
    get testStufe() { return !!(zustand && zustand.stufe_override === true && (!stufeOverride || stufeOverride === zustand.stufe)); },
    api: API, demo: DEMO,
    bereit: start()
  };
})(window);
